/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Group_PlaceholderInputs */

const en_editor_group_placeholder = /** @type {(inputs: Editor_Group_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group, e.g. Sauce`)
};

const de_editor_group_placeholder = /** @type {(inputs: Editor_Group_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe, z. B. Sauce`)
};

/**
* | output |
* | --- |
* | "Group, e.g. Sauce" |
*
* @param {Editor_Group_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_group_placeholder = /** @type {((inputs?: Editor_Group_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Group_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_group_placeholder(inputs)
	return en_editor_group_placeholder(inputs)
});